import { useFormsTemplatesListController } from '@dealstack/frontend/app/pages/Project/MIP/MIPCreate/KYCRequirements/common/FormsTemplatesList/useFormsTemplatesListController.tsx';
import { useTranslationMipCreate } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { DataCustomDetailTct } from '@dealstack/shared/lib/generated';
import { memo } from 'react';
import { SquareUploader } from '@dealstack/frontend/shared/components/SquareUploader/SquareUploader';
import { KycDocumentCard } from '@dealstack/frontend/app/pages/Project/MIP/MIPCreate/KYCRequirements/common/FormsTemplatesList/KycDocumentCard/KycDocumentCard.tsx';
import { Flex } from '@mantine/core';
import { CreateKycDocumentDrawer } from '@dealstack/frontend/app/pages/Project/MIP/MIPCreate/KYCRequirements/common/FormsTemplatesList/CreateKycDocumentDrawer/CreateKycDocumentDrawer.tsx';
import {
	TEST_ELEMENT_IDS,
	UIElementIdentifier,
} from '@dealstack/frontend/shared/helper/UIElementIdentifier/UIElementIdentifier';

interface Props {
	type: DataCustomDetailTct['type'];
	/** Data test ID for the file input element used in E2E testing */
	fileInputDataTestId?: string;
}

const FormsTemplatesList = ({ type, fileInputDataTestId }: Props) => {
	const tMipCreate = useTranslationMipCreate();
	const {
		formsTemplates,
		uploadedFile,
		uploadFileRequest,
		addFormTemplate,
		removeFormTemplate,
		fieldArrayName,
	} = useFormsTemplatesListController(type);

	return (
		<Flex gap="0.5rem" wrap="wrap">
			<SquareUploader
				uploadFileRequest={uploadFileRequest}
				accept={{ 'application/pdf': ['.pdf'] }}
				invalidTypeMessage={tMipCreate('contracts.table.errors.invalid_file_type')}
				multiple={false}
				dataTestId={fileInputDataTestId}
			/>

			{formsTemplates?.map((template, index) => (
				<UIElementIdentifier identifier={TEST_ELEMENT_IDS.MIP_CREATE_KYC_DOCUMENT_CARD}>
					<KycDocumentCard
						key={template.id}
						formTemplate={template}
						removeFormTemplate={removeFormTemplate}
						formTemplateFieldKey={`${fieldArrayName}.${index}`}
						onDelete={() => {
							removeFormTemplate(index);
						}}
					/>
				</UIElementIdentifier>
			))}

			{!!uploadedFile?.id && (
				<CreateKycDocumentDrawer
					addFormTemplate={addFormTemplate}
					onClose={uploadFileRequest.resetInstance}
					file={uploadedFile}
					opened={!!uploadedFile?.id}
					type={type}
				/>
			)}
		</Flex>
	);
};
const _FormsTemplatesListExport = memo(FormsTemplatesList);

export { _FormsTemplatesListExport as FormsTemplatesList };
